import { getAPI } from "./axios-base";
import Admin from "@/models/Admin";
import Checker from "@/models/Checker";

interface GetClientsParams {
  skip: number;
  limit: number;
  q: string;
  name: string;
  email: string;
}
export default class RestResourceClient {
  getClients(params: GetClientsParams) {
    console.log(params);
    return getAPI.get(`api/rest/v1/user`, { params });
  }
  getClient(id: string) {
    return getAPI.get(`api/rest/v1/user/${id}`);
  }
  getEmails(params: GetClientsParams) {
    console.log(params);
    return getAPI.get(`api/rest/v1/email-confirmation`, { params });
  }
  getPhones(params: GetClientsParams) {
    console.log(params);
    return getAPI.get(`api/rest/v1/phone-confirmation`, { params });
  }
}
